<template>
  <div class="scroll-number">{{ formattedValue }}</div>
</template>
<script>
import { divideSymbol } from "@/lobby_common/utils/utils.js";
export default {
  props: {
    finalValue: {
      type: Number,
      default: 100,
    },
    initiaValue: {
      type: Number,
      default: 0,
    },
    decimal: {
      type: Number,
      default: 2,
    },
    showThousand: {
      type: Boolean,
      default: true,
    },
    updateInterval: {
      type: Number,
      default: 1000,
    },
    proportion: {
      type: Number,
      default: 0.0001,
    },
    maxRate: {
      type: Number,
      default: 1.9,
    },
    minRate: {
      type: Number,
      default: 0.1,
    },
  },
  data() {
    return {
      // initiaValue: this.finalValue * 0.8,
      currentValue: 0,
      intervalId: null,
    };
  },
  computed: {
    formattedValue() {
      const formatted = this.currentValue.toFixed(this.decimal);
      // if (this.showThousand) {
      //     formatted = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      // }
      // return formatted;
      return divideSymbol(formatted);
    },
  },
  watch: {
    initiaValue: {
      handler(newVal) {
        this.currentValue = newVal;
      },
      immediate: true,
    },
    // finalValue: function(newVal) {
    //     if (this.currentValue === this.initiaValue) {
    //         this.startIncrement();
    //     }
    // }
  },
  mounted() {
    this.startIncrement();
  },
  methods: {
    startIncrement() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      // const minIncrement = this.finalValue * 0.01;

      this.intervalId = setInterval(() => {
        if (this.finalValue < 1) return;
        if (this.currentValue < this.finalValue * 0.95) {
          const randomIncrement =
            Math.random() * (this.maxRate - this.minRate) + this.minRate;
          const maxIncrement =
            this.finalValue * this.proportion * randomIncrement;
          // const maxIncrement = this.finalValue * this.proportion;
          this.currentValue += maxIncrement;

          if (this.currentValue > this.finalValue * 0.95) {
            this.currentValue = this.finalValue * 0.8;
          }
        } else {
          this.currentValue = this.finalValue * 0.8;
        }
      }, this.updateInterval);
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
};
</script>
